import DatePicker from 'antd/lib/date-picker';
import 'antd/lib/date-picker/style/index.css';

export default DatePicker;
